import React, { useEffect, useState } from 'react';
import DataTable from "./DataTable";
import DropdownMenu from "./DropdownMenu";
import FilterRightMenu from "./FilterRightMenu";
import Form from "./Form";
import TableHeader from "./TableHeader";
import { HeadLine } from "../../component";
import {isAdmin} from "../../../utils/jwtUtil";

const MintsContent = () => {
  const [isAdminUser, setIsAdminUser] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      const isAdminResponse = await isAdmin();
      setIsAdminUser(isAdminResponse);
    };

    checkAdminStatus();
  }, []);

  if (!isAdminUser) {
    return null; // Do not render if user is not an admin
  }

  return (
    <div
      role="table"
      className="container rounded-2lg border border-jacarta-100 bg-white text-sm dark:border-jacarta-600 dark:bg-jacarta-700 dark:text-white"
    >
      <HeadLine
          text="Project Admin"
          classes="font-display text-jacarta-700 mb-8 text-center text-3xl dark:text-white"
      />
      <div className="flex flex-col gap-4 rounded-t-2lg border-b border-jacarta-100 bg-jacarta-50 p-4 dark:border-jacarta-600 dark:bg-jacarta-800 sm:gap-6 lg:flex-row lg:items-center">
        <div className="flex flex-1 flex-col justify-between gap-4 md:flex-row md:items-center md:gap-10">
          <div className="relative flex w-full flex-1">
            <Form />
          </div>
        </div>
        {/* End flex */}

        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center lg:justify-start">
          <DropdownMenu />
          <FilterRightMenu />
        </div>
        {/* End flex */}

      </div>

      <TableHeader />
      <DataTable />
    </div>
  );
};

export default MintsContent;